import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { db } from '../../firebase/firebase-config';

const REVI_STRIPE_API = process.env.REACT_APP_STRIPE_API_URL || 'https://revi-stripe-service-717967703066.us-central1.run.app';

export const PasoSuscripcion = ({ siguiente, anterior }) => {
    const { hashtag, email, nombre } = useSelector(state => state.auth);
    const [cargando, setCargando] = useState(false);
    const [error, setError] = useState(null);
    const [numColaboradoras, setNumColaboradoras] = useState(null);

    // Contar colaboradoras al cargar para mostrar el precio real
    useEffect(() => {
        const contar = async () => {
            try {
                const colSnap = await db.collection(`general/${hashtag}/consultores`).get();
                setNumColaboradoras(colSnap.size || 1);
            } catch (e) {
                setNumColaboradoras(1);
            }
        };
        if (hashtag) contar();
    }, [hashtag]);

    // Cálculo del precio: $899 base (1-2 colaboradoras) + $300 por cada adicional, más IVA
    const num = numColaboradoras || 1;
    const adicionales = Math.max(0, num - 2);
    const subtotal = 899 + adicionales * 300;
    const iva = subtotal * 0.16;
    const totalConIva = subtotal + iva;

    const handleSuscribirse = async () => {
        setCargando(true);
        setError(null);

        try {
            const res = await fetch(`${REVI_STRIPE_API}/stripe/crear-sesion`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    hashtag,
                    email,
                    numeroColaboradoras: num
                })
            });

            const data = await res.json();

            if (!res.ok) throw new Error(data.error || 'Error al crear sesión');

            // Redirigir a Stripe Checkout
            window.location.href = data.url;

        } catch (e) {
            setError('Hubo un problema al conectar con el servidor. Intenta de nuevo.');
            setCargando(false);
        }
    };

    return (
        <div className="app-container" style={{ position: 'relative' }}>
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '32px 24px' }}>

                <div style={{ width: 72, height: 72, borderRadius: '50%', background: 'var(--pink-100)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 34, marginBottom: 16 }}>
                    💳
                </div>

                <h1 style={{ fontSize: 22, fontWeight: 700, color: 'var(--pink-900)', marginBottom: 8, textAlign: 'center' }}>
                    Activa tu suscripción
                </h1>
                <p style={{ fontSize: 14, color: 'var(--pink-800)', lineHeight: 1.7, marginBottom: 24, textAlign: 'center' }}>
                    Empieza con <strong>30 días gratis</strong>. No se te cobra nada hoy — solo registras tu tarjeta para continuar después del periodo de prueba.
                </p>

                {/* Detalles del plan */}
                <div style={{ background: 'var(--pink-50)', border: '0.5px solid var(--border)', borderRadius: 12, padding: 16, width: '100%', marginBottom: 20 }}>
                    <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--pink-900)', marginBottom: 12 }}>
                        📋 Tu plan
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 14, color: 'var(--pink-800)', marginBottom: 8 }}>
                        <span>Plan base (hasta 2 colaboradoras)</span>
                        <span style={{ fontWeight: 600 }}>$899</span>
                    </div>
                    {adicionales > 0 && (
                        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 14, color: 'var(--pink-800)', marginBottom: 8 }}>
                            <span>{adicionales} colaboradora{adicionales > 1 ? 's' : ''} extra × $300</span>
                            <span style={{ fontWeight: 600 }}>${adicionales * 300}</span>
                        </div>
                    )}
                    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, color: 'var(--pink-700)', marginBottom: 8 }}>
                        <span>Subtotal</span>
                        <span>${subtotal.toFixed(2)}</span>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, color: 'var(--pink-700)', marginBottom: 8 }}>
                        <span>IVA (16%)</span>
                        <span>${iva.toFixed(2)}</span>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 15, fontWeight: 700, color: 'var(--pink-900)', borderTop: '0.5px solid var(--border)', paddingTop: 10, marginTop: 4 }}>
                        <span>Total mensual</span>
                        <span>${totalConIva.toFixed(2)} MXN</span>
                    </div>
                    <div style={{ borderTop: '0.5px solid var(--border)', paddingTop: 10, marginTop: 10, fontSize: 13, color: 'var(--pink-700)' }}>
                        ✓ 30 días de prueba gratis<br />
                        ✓ Cancela cuando quieras<br />
                        ✓ Citas ilimitadas por WhatsApp
                    </div>
                </div>

                {error && (
                    <div style={{ background: '#fff0f0', border: '0.5px solid #ffcccc', borderRadius: 8, padding: 12, width: '100%', marginBottom: 16, fontSize: 13, color: '#cc0000', textAlign: 'center' }}>
                        {error}
                    </div>
                )}

                <button
                    className="btn-primary"
                    style={{ width: '100%', marginBottom: 12 }}
                    onClick={handleSuscribirse}
                    disabled={cargando || numColaboradoras === null}
                >
                    {cargando ? 'Redirigiendo...' : 'Registrar tarjeta y empezar prueba →'}
                </button>

                <button
                    onClick={anterior}
                    style={{ background: 'none', border: 'none', color: 'var(--pink-700)', fontSize: 14, cursor: 'pointer', padding: 8 }}
                >
                    ← Regresar
                </button>
            </div>
        </div>
    );
};
